export const termsData = {
  title: 'Terms & Conditions',
  subtitle:
    'These Terms & Conditions govern your use of the Next-G Services website  and services. By accessing our site, you agree to comply with these terms.',
  sections: [
    {
      id: 1,
      icon: 'FileText',
      title: '1. Acceptance of Terms',
      content: [
        'By using our website, you agree to be bound by these Terms & Conditions.',
        'If you do not agree, please do not use our site or services.',
      ],
    },
    {
      id: 2,
      icon: 'ShieldCheck',
      title: '2. Use of Website',
      content: [
        'You may use our website for lawful purposes only.',
        'You must not attempt to access unauthorized areas or compromise website security.',
      ],
    },
    {
      id: 3,
      icon: 'UserCheck',
      title: '3. Services Disclaimer',
      content: [
        'All services listed are subject to availability.',
        'Next-G Services does not guarantee that every service will be suitable for every property or requirement.',
      ],
    },
    {
      id: 4,
      icon: 'Lock',
      title: '4. Intellectual Property',
      content: [
        'All content on this website, including images, text, and logos, is owned by Next-G Services or its licensors.',
        'You may not reproduce, distribute, or use this content without written permission.',
      ],
    },
    {
      id: 5,
      icon: 'PhoneCall',
      title: '5. Liability Limitation',
      content: [
        'Next-G Services is not responsible for any direct or indirect damages arising from the use of our website.',
        'Use of services is at your own risk, and we advise checking suitability before hiring any contractor.',
      ],
    },
    {
      id: 6,
      icon: 'BadgeCheck',
      title: '6. Changes to Terms',
      content: [
        'We may update these Terms & Conditions at any time without prior notice.',
        'Changes will be effective immediately upon posting on the website.',
      ],
    },
    {
      id: 7,
      icon: 'Cookie',
      title: '7. Governing Law',
      content: [
        'These terms are governed by the laws of the United Kingdom.',
        'Any disputes arising from use of the website or services will be subject to the exclusive jurisdiction of UK courts.',
      ],
    },
  ],
  footer: {
    rights: '© Next-G Services. All rights reserved.',
    updated: 'Last updated: November 2025',
  },
};
